import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, updateDoc, doc, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import './TrendingPage.css';

const TrendingPage = () => {
  const [projects, setProjects] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const projectsSnapshot = await getDocs(collection(db, 'projects'));
      const projectsData = projectsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        upvotes: doc.data().upvotes || [],
        downvotes: doc.data().downvotes || [],
      }));
      projectsData.sort((a, b) => 
        (b.upvotes.length - b.downvotes.length) - (a.upvotes.length - a.downvotes.length)
      );
      setProjects(projectsData);
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const handleVote = async (e, projectId, voteType) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      alert('Please login to vote');
      return;
    }
    const projectRef = doc(db, 'projects', projectId);
    const project = projects.find(p => p.id === projectId);
    try {
      if (voteType === 'up') {
        if (project.upvotes.includes(user.uid)) {
          await updateDoc(projectRef, { upvotes: arrayRemove(user.uid) });
        } else {
          await updateDoc(projectRef, {
            upvotes: arrayUnion(user.uid),
            downvotes: arrayRemove(user.uid),
          });
        }
      } else {
        if (project.downvotes.includes(user.uid)) {
          await updateDoc(projectRef, { downvotes: arrayRemove(user.uid) });
        } else {
          await updateDoc(projectRef, {
            downvotes: arrayUnion(user.uid),
            upvotes: arrayRemove(user.uid),
          });
        }
      }
      await fetchProjects();
    } catch (error) {
      console.error('Error voting:', error);
    }
  };

  return (
    <div className="trending-page">
      <h1>Trending Projects</h1>
      <div className="projects-list">
        {projects.map(project => {
          const score = (project.upvotes?.length || 0) - (project.downvotes?.length || 0);
          const hasUpvoted = user && project.upvotes.includes(user.uid);
          const hasDownvoted = user && project.downvotes.includes(user.uid);
          return (
            <Link
              to={project.userId === user.uid ? `/project/${project.id}` : `/display/${project.id}`}
              key={project.id}
              className="project-card"
            >
              <div className="project-header">
                <div className="header-left">
                  <h3 className="project-title">{project.title || 'Untitled Project'}</h3>
                </div>
                <div className="header-right">
                  <button 
                    className={`vote-button ${hasUpvoted ? 'active' : ''}`}
                    onClick={(e) => handleVote(e, project.id, 'up')}
                  >
                    <FaArrowUp />
                  </button>
                  <span className="vote-score">{score}</span>
                  <button 
                    className={`vote-button ${hasDownvoted ? 'active' : ''}`}
                    onClick={(e) => handleVote(e, project.id, 'down')}
                  >
                    <FaArrowDown />
                  </button>
                </div>
              </div>
              <hr className="project-divider" />
              <div className="project-body">
                <p className="project-description">
                  {project.lastMessage || 'No description available.'}
                </p>
                <div className="project-meta">
                  <span className="created-date">
                    Created: {new Date(project.createdAt).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default TrendingPage;